import React from 'react';
import { useTranslator } from '@front-activerse/common-components';
import Layout from '../../Layout/Layout';
import TitleBar from '../../Layout/TitleBar';
import WearablesDashboardContainer from './WearablesDashboardContainer';

const WearablesDashboardPage: React.FC = () => {
  const { t } = useTranslator();

  return (
    <Layout>
      <TitleBar showBackBtn={false}>{t('wearablesDashboard.pageTitle')}</TitleBar>
      <section className="page-template-wearables-dashboard full-height3a">
        <WearablesDashboardContainer />
      </section>
    </Layout>
  );
};

export default WearablesDashboardPage;
